import React from 'react'
import styles from './LbSupportSection.module.css'
import { motion } from 'framer-motion'
import { FaEnvelope, FaWhatsapp, FaBookOpen } from 'react-icons/fa'
import { Link } from 'react-router'

const LbSupportSection = () => {
    return (
        <div>
            <div className={styles.pageHeader}>
                <Link to={`/leadbridge`} className={styles.phlWrapper}>
                    LeadBridge™
                </Link>
                <div className={styles.phrWrapper}>
                    <Link to={`/leadbridge/dashboard`}>
                        Go To Dashboard
                    </Link>
                    <Link to={`/leadbridge/help`}>
                        Help
                    </Link>
                </div>
            </div>
            <div className={styles.supportContainer}>

                <motion.div
                    className={styles.inner}
                    initial={{ opacity: 0, y: 40 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6 }}
                >
                    <h2>Need Help?</h2>
                    <p>Our team is here to ensure your success with LeadBridge.</p>

                    <div className={styles.options}>
                        <a href="mailto:info@lokaci.com" className={styles.supportCard}>
                            <FaEnvelope className={styles.icon} />
                            <div>
                                <h4>Email Us</h4>
                                <p>Get support via email. Response within 24 hours.</p>
                            </div>
                        </a>
                        <a href="https://wa.me/919999999999" target="_blank" rel="noopener noreferrer" className={styles.supportCard}>
                            <FaWhatsapp className={styles.icon} />
                            <div>
                                <h4>Chat on WhatsApp</h4>
                                <p>Instant help during working hours.</p>
                            </div>
                        </a>
                        <a href="/leadbridge/docs" className={styles.supportCard}>
                            <FaBookOpen className={styles.icon} />
                            <div>
                                <h4>Read Docs</h4>
                                <p>Explore our guides and developer resources.</p>
                            </div>
                        </a>
                    </div>
                </motion.div>
            </div>
        </div>
    )
}

export default LbSupportSection
